export default __webpack_public_path__ + "static/Going_places-b6e1182a7c786cd9e0294c8c93d9d852.jpg";